import Hotboard from "components/Briefing/tables/hotboard";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from "reactstrap";
import { setShift } from "redux/briefing/shiftSlice";
import TransferAssignmentsBoard from "./transferAssignmentsBoard";
import CriticalDrivers from "./tables/criticalDrivers";
import LoadPlanningHeadTable from "./tables/loadPlanningHead";
import MiscNotes from "./tables/miscNotes";
import ActiveTransitPartials from "./tables/newTransitPartials";
import PreloadedTrailers from "./tables/preloadedTrailers";
import QuotingBriefing from "./tables/quotingHead";
import RadicalRadar from "./tables/radicalRadar";
import TrackAndTraceBriefing from "./tables/trackAndTraceHead";
import UnconfimedDeliveryTimesBoard from "./unconfirmedDeliveryTimesBoard";

const CurrentBriefing = () => {
    const shift = useSelector((state) => state.shift);
    const briefing = useSelector((state) => state.briefing.line);
    const [openSections, setOpenSections] = useState({
        Bulletin: true,
        Quoting: false,
        TrackAndTrace: false,
        LoadPlanning: false,
    });

    const dispatch = useDispatch();

    const handleShiftClick = (newShift) => {
        dispatch(setShift(newShift));
    };

    return (
        <>
            <div className="main-container">
                <div className="pulse-section pt-0 mt-3">
                    <div className="pulse-header">
                        <h1>Bulletin</h1>
                        <button
                            className="button"
                            onClick={() => setOpenSections({ ...openSections, Bulletin: !openSections.Bulletin })}
                        >
                            <i className={`fa ${openSections.Bulletin ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">General briefings:- Hotboard, Radical Radar, Miscellaneous Notes, Critical Drivers</p>
                        <hr />
                        <Collapse isOpen={openSections.Bulletin}>
                            <Hotboard />
                            <RadicalRadar />
                            <MiscNotes />
                            <CriticalDrivers />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="table-header pulse-header">
                        <h1>Quoting</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, Quoting: !openSections.Quoting })}
                        >
                            <i className={`fa ${openSections.Quoting ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Quoting team briefing</p>
                        <hr />
                        <Collapse isOpen={openSections.Quoting}>
                            <QuotingBriefing />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="table-header pulse-header">
                        <h1>Track &Trace</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, TrackAndTrace: !openSections.TrackAndTrace })}
                        >
                            <i className={`fa ${openSections.TrackAndTrace ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Track &Trace briefings:- Orders with Unconfirmed Delivery Times</p>
                        <hr />
                        <Collapse isOpen={openSections.TrackAndTrace}>
                            <TrackAndTraceBriefing />
                            <hr />
                            <UnconfimedDeliveryTimesBoard />
                        </Collapse>
                    </div>
                </div>

                <hr />

                <div className="pulse-section pt-0 mt-3">
                    <div className="table-header pulse-header">
                        <h1>Load Planning</h1>
                        <button
                            className="button section-toggle"
                            onClick={() => setOpenSections({ ...openSections, LoadPlanning: !openSections.LoadPlanning })}
                        >
                            <i className={`fa ${openSections.LoadPlanning ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                        </button>
                    </div>
                    <div className="pulse-body">
                        <p className="text-muted">Load Planning team briefing:- Preloaded Trailers, Transit Partials, Transfer Assignments</p>
                        <hr />
                        <Collapse isOpen={openSections.LoadPlanning}>
                            <PreloadedTrailers />
                            <ActiveTransitPartials />
                            <LoadPlanningHeadTable />
                            <hr />
                            <TransferAssignmentsBoard />
                        </Collapse>
                    </div>
                </div>

                <hr />

            </div>
            {briefing === 'Briefings' && (
                <div className="multi-button-hover-container">
                    <button
                        active={shift === 'first' ? 'true' : 'false'}
                        onClick={() => handleShiftClick('first')}
                        className='hovering-button first'
                    >
                        1st Shift
                    </button>
                    <button
                        active={shift === 'second' ? 'true' : 'false'}
                        onClick={() => handleShiftClick('second')}
                        className='hovering-button second'
                    >
                        2nd Shift
                    </button>
                    <button
                        active={shift === 'third' ? 'true' : 'false'}
                        onClick={() => handleShiftClick('third')}
                        className='hovering-button third'
                    >
                        3rd Shift
                    </button>
                </div>
            )}
        </>
    );
};

export default CurrentBriefing;
